import { connect } from 'react-redux';

//=====引入组件=====
import App from '../../App.js'


//=====react-redux 封装组件=====

// 哪些 Redux 全局的 state 是我们组件想要通过 props 获取的？
function mapStateToProps(state) {
    return {
        info: state.data.info,
        ismobile: state.data.ismobile,
    }
}

// 哪些 action 创建函数是我们想要通过 props 获取的？
function mapDispatchToProps(dispatch) {
    return {
        GET_INFO: function () {
            let action = {
                type: "GET_INFO",
                // info: info,
            }
            dispatch(action);
        },
        OUT_LOGIN: function () {
            setTimeout(function () {
                dispatch({ type: "OUT_LOGIN" })
            }, 0)
        },
        IS_MOBILE: function () {
            dispatch({ type: "IS_MOBILE" })
        },
    };
}

//封装传递state和dispatch
var AppAction = connect(mapStateToProps, mapDispatchToProps)(App);

export default AppAction